import { Text } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { price } from '@eti/utils';
import { Price, CartRow } from './CartComponents';

const euroCurrencyPriceFormat = {
  currencyName: 'Euro',
  currencySymbol: '€',
  decimalSymbol: '.',
  currencyExponent: 2,
  groupingSeparator: ' ',
  pattern: '#,##0.00 ¤;-#,##0.00 ¤',
};
const euroPriceFormatter = price.createPriceFormatter(euroCurrencyPriceFormat);

interface PriceInEuroProps {
  dataTestId: string;
  totalPriceWithFees: number;
}

const PriceInEuro = ({ dataTestId, totalPriceWithFees }: PriceInEuroProps) => {
  const { t } = useTranslation();
  const { p } = useProperty();

  const priceInEuro = euroPriceFormatter.formatPrice(
    totalPriceWithFees * p('IbeClient.DualCroatianCurrency.ExchangeRate'),
  );
  return (
    <CartRow>
      <Text>{t('IbeClient.DualCroatianCurrency.Label')}</Text>
      <Price data-testid={`${dataTestId}-DualCroatianCurrency`}>{priceInEuro}</Price>
    </CartRow>
  );
};

export default PriceInEuro;
